import { APP_INITIALIZER } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { AppConfigService } from './common/get-latest-version.service';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule  } from '@angular/core';
import { AuthModule } from './auth/auth.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CmsRoutingModule } from './cms/cms-routing.module';
import { CmsComponent } from './cms/cms.component';
import { LayoutModule } from './cms/layout/layout.module';
import { AuthGuard } from './common/auth.guard';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { GridModule } from '@progress/kendo-angular-grid';
import { TranslateModule, TranslateLoader, TranslateService } from '@ngx-translate/core';
import { TranslatePipe } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { ApiTranslateLoader } from './common/api-translate-loader';
import { NotificationModule } from '@progress/kendo-angular-notification';
import { PopupModule } from '@progress/kendo-angular-popup';
import { DialogsModule } from '@progress/kendo-angular-dialog';
import { EditorModule } from '@progress/kendo-angular-editor';
import { TreeViewModule } from '@progress/kendo-angular-treeview';
import { PageNotFoundComponent } from './page-not-found/page-not.found';
import { CustomReusingStrategy } from './common/CustomReusingStrategy';
import { RouteReuseStrategy } from '@angular/router';
import { PermissionGuard } from './common/permission.guard';
import { CourseEnrollmentGuard } from '../app/cms/pages/default/e-learning/guards/course-enrollment.guard';
import { QualityControlGuard } from '../app/cms/pages/default/quality_control/guards/quality_control.guard';
import { NavigationHistoryService } from './common/navigation-history.service';
import { TicketModule } from './cms/pages/default/ticket/ticket.module';
import { DraggableDirective } from './common/draggable.directive';
import { ICON_SETTINGS } from '@progress/kendo-angular-icons';
import { MenuModule } from '@progress/kendo-angular-menu';
import { VersionComponent } from './version/version.component';
import { VersionCheckService } from './common/version.service';

export function HttpLoaderFactory(http: HttpClient) {
  return new ApiTranslateLoader(http);
}

export function initApp(appConfig: AppConfigService) {
  return () => appConfig.load();
}

export function initTranslations(translate: TranslateService) {
  return async () => {
    localStorage.removeItem('translations_version');
    ['de', 'fr', 'it', 'en'].forEach((l) => localStorage.removeItem(`translations_${l}`));

    const lang = localStorage.getItem('language') || 'de';
    translate.setDefaultLang(lang);
    try {
      return await firstValueFrom(translate.use(lang));
    } catch {
      return undefined;
    }
  };
}

@NgModule({
  declarations: [
    AppComponent,
    CmsComponent,
    PageNotFoundComponent,

    VersionComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    AuthModule,
    CmsRoutingModule,
    TicketModule,
    LayoutModule,
    ButtonsModule,
    BrowserAnimationsModule,
    GridModule,
    NotificationModule,
    TranslateModule.forRoot({
      loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient]
      }
   }),
    PopupModule,
    DialogsModule,
    EditorModule,
    TreeViewModule,
    MenuModule,
    /*ChatBoxModule*/
  ],
  exports: [TranslateModule, TranslatePipe],
  providers: [
    AppConfigService,
    {
      provide: APP_INITIALIZER,
      useFactory: initApp,
      deps: [AppConfigService],
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initTranslations,
      deps: [TranslateService],
      multi: true
    },
    AuthGuard,
    NavigationHistoryService,
    PermissionGuard,
    CourseEnrollmentGuard,
    QualityControlGuard,
    VersionCheckService,
    { provide: RouteReuseStrategy, useClass: CustomReusingStrategy },
    { provide: ICON_SETTINGS, useValue: { type: 'font' } }
  ],

  bootstrap: [AppComponent]
})
export class AppModule { }
